/**
 * Biometric-login metadata persisted in a single `LocalStorageFacade` object
 * (key `biometric` → `actuar/biometric`). It survives sign out (`clearSession`
 * only removes the auth + webauthn keys), so the "welcome back" gate can render
 * the last user's identity while logged out. The auth session itself is NOT kept
 * here — it lives in the OS Keychain/Keystore.
 */
export interface IBiometricInfo {
  /** Biometric login is enrolled for this device. */
  Enabled: boolean;
  /** Last account's PersonId — resolves the welcome-card avatar. */
  PersonId: string | null;
  /** Display name on the welcome card. */
  UserName: string | null;
  /** Display email on the welcome card. */
  UserEmail: string | null;
}

export const BIOMETRIC_INFO_DEFAULTS: IBiometricInfo = {
  Enabled: false,
  PersonId: null,
  UserName: null,
  UserEmail: null,
};

/** `LocalStorageFacade` key (prefixed to `actuar/biometric`). */
export const BIOMETRIC_INFO_KEY = 'biometric';
